import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import Preloader from '../preloader';
import { TableStyled } from './index.styled';
import { TableContainerStyled } from './index.styled';
import TableBody from './table-body';
import TableHeaderRow from './table-header-row';
import { CtxWrapper } from './reducer/ctx';
import { TDataInterface, TMaterialTable } from './index.types';

const MaterialTable = <T extends TDataInterface>({
    data,
    columns,
    isLoading,
    setOrderBy,
    setOrderAsc,
    orderBy,
    orderAsc,
    onClickRow,
}: TMaterialTable<T>): JSX.Element => {
    return (
        <CtxWrapper>
            <TableContainerStyled component={Paper} clickable={!!onClickRow}>
                <Preloader isShown={isLoading} />
                {data && Array.isArray(data) && (
                    <TableStyled>
                        <TableHead>
                            <TableHeaderRow
                                columns={columns}
                                orderBy={orderBy}
                                orderAsc={orderAsc}
                                setOrderBy={setOrderBy}
                                setOrderAsc={setOrderAsc}
                            />
                        </TableHead>
                        <TableBody<T>
                            columns={columns}
                            data={data}
                            onClickRow={onClickRow}
                        />
                    </TableStyled>
                )}
            </TableContainerStyled>
        </CtxWrapper>
    );
};

export default MaterialTable;
